var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, AlertTitle, Button, Card, Grid, Typography, } from "@mui/material";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { getDebitos } from "../../apis/api";
import Loader from "../Loading";
import * as IconesVeiculos from "../ui/icons/car/";
import styles from "./index.module.css";
import { useWebgate } from "@xvia/webgate-connect";
export var InformacaoVeiculo = function (_a) {
    var veiculos = _a.veiculos;
    var history = useHistory();
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var accessToken = useWebgate().accessToken;
    var publicUrl = process.env.PUBLIC_URL || "/static-content/ipva";
    if (veiculos.length === 0) {
        return (_jsxs(Alert, __assign({ severity: "warning" }, { children: [_jsx(AlertTitle, { children: "Informa\u00E7\u00E3o:" }), _jsx("p", { children: "N\u00E3o foi localizado ve\u00EDculos para este usu\u00E1rio." })] })));
    }
    var obterLogoVeiculoPorDescricao = function (descricao) {
        var icone = Object.keys(IconesVeiculos).find(function (icone) {
            return descricao.includes(icone);
        });
        if (!icone) {
            console.error("Ícone não encontrado para o veículo: ", descricao);
        }
        return icone;
    };
    function handleDebitos(veiculo) {
        return __awaiter(this, void 0, void 0, function () {
            var response, obj, errosStr, errosObj, errosArray, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!accessToken) {
                            toast.error("Token de autenticação não encontrado");
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        return [4 /*yield*/, getDebitos({
                                placa: veiculo.placa.toUpperCase(),
                                renavam: String(veiculo.renavam),
                            }, accessToken)];
                    case 2:
                        response = _a.sent();
                        if (response.data.status === "FALHA") {
                            console.log("***************");
                            obj = JSON.parse(JSON.stringify(response.data));
                            errosStr = obj.data.erros;
                            errosObj = JSON.parse(errosStr);
                            errosArray = errosObj.erros;
                            errosArray.map(function (item) {
                                return toast.warn(item);
                            });
                        }
                        else {
                            history.push({
                                pathname: "/dar-ipva/debitos",
                                state: response.data,
                            });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        toast.error(String(error_1) || "Algo deu errado");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), veiculos.map(function (v) { return (_jsx(Card, __assign({ className: styles.card }, { children: _jsxs(Grid, __assign({ container: true, alignItems: "center", justifyContent: "space-around" }, { children: [_jsx(Grid, __assign({ item: true, xs: 1, display: "flex", alignItems: "center", justifyContent: "center" }, { children: _jsx("img", { className: styles.image, src: "".concat(publicUrl, "/images/").concat(obterLogoVeiculoPorDescricao(v.marca.toLowerCase()), ".svg"), alt: "".concat(v.marca, " Logo") }) })), _jsxs(Grid, __assign({ item: true, className: styles.grid, xs: 12, sm: 12, md: 3, lg: 3 }, { children: [_jsxs("div", __assign({ className: styles.itemInfo }, { children: [_jsx(Typography, __assign({ className: styles.label }, { children: "Marca/Modelo" })), _jsx(Typography, __assign({ className: styles.text }, { children: "".concat(v.marca, "/").concat(v.modelo) }))] })), _jsxs("div", __assign({ className: styles.itemInfo }, { children: [_jsx(Typography, __assign({ className: styles.label }, { children: "Licenciamento" })), _jsx(Typography, __assign({ className: styles.text }, { children: v.anoLicenciamento }))] }))] })), _jsxs(Grid, __assign({ item: true, className: styles.grid, xs: 12, sm: 12, md: 3, lg: 3 }, { children: [_jsxs("div", __assign({ className: styles.itemInfo }, { children: [_jsx(Typography, __assign({ className: styles.label }, { children: "Placa" })), _jsx(Typography, __assign({ className: styles.text }, { children: v.placa }))] })), _jsxs("div", __assign({ className: styles.itemInfo }, { children: [_jsx(Typography, __assign({ className: styles.label }, { children: "Renavam" })), _jsx(Typography, __assign({ className: styles.text }, { children: v.renavam }))] }))] })), _jsx(Grid, __assign({ className: styles.containerBotao }, { children: _jsx(Button, __assign({ className: styles.botao, onClick: function () { return handleDebitos(v); } }, { children: _jsx(Typography, __assign({ className: styles.textoBotao }, { children: "Ver D\u00E9bitos" })) })) }))] })) }), v.chassi)); })] }));
};
